import React from "react";
import PropTypes from "prop-types";

const LaborDataItem = ({ itemAmount, itemTitle }) => {
  return (
    <div className="labor-data-item-container">
      <div className="labor-data-title">{itemTitle}</div>
      <div className="labor-data">{itemAmount}</div>
    </div>
  );
};

LaborDataItem.propTypes = {
  itemTitle: PropTypes.node,
  itemAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default LaborDataItem;
